module.exports = __webpack_public_path__ + "img/report-4.aeba237e.jpg";